import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import {observer} from "mobx-react-lite";
import {useStore} from "../../../../hooks/useStore";
import api from "../../../../api/api";

const InputBox = observer(({value: old_value, id, index_box, user_id, score: isNan, updateInput, penalty, is_read}) => {
        const {figure} = useStore()
        const [isReadOnly, setIsReadOnly] = useState(true);
        const [score, setScore] = useState(old_value || '')

        const handleDoubleClick = () => {
            setIsReadOnly(false); // Убираем readOnly при двойном клике
        };

        const handlerSetScore = async (value) => {
            setIsReadOnly(true);
            if (penalty) {

                const res = await figure.setPenalty(value, id, index_box, old_value, setScore);
            } else {
                const res = await figure.setScore(value, id, index_box, user_id, old_value, setScore);
            }
        }
        const numberInputOnWheelPreventChange = (e) => {
            e.target.blur()
        }

        useEffect(() => {
            setScore(old_value || '')
        }, [updateInput])
        return (
            penalty === true ?
                <input
                    tabIndex={-1}
                    readOnly={isReadOnly}
                    onDoubleClick={handleDoubleClick}
                    step={0.01}
                    value={score}
                    onWheel={numberInputOnWheelPreventChange}
                    onBlur={(e) => {
                        handlerSetScore(e.target.value)
                    }}
                    onChange={(e) => setScore(e.target.value)}
                    type={'number'}
                    className={s.input_box}/> :
                <input
                    readOnly={is_read}
                    tabIndex={is_read ? -1 : 0}
                    step={0.01}
                    value={score}
                    onWheel={numberInputOnWheelPreventChange}
                    onBlur={(e) => {
                        handlerSetScore(e.target.value)
                    }}
                    onFocus={(e) => {
                        if (is_read) {
                            e.target.blur();
                        }
                    }}
                    onChange={(e) => setScore(e.target.value)}
                    type={'number'}
                    className={s.input_box}/>

        );
    })
;

export default InputBox;
